var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 746.744,
    height: 746.744,
    viewBox: "0 0 746.744 746.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-0.382 -91.481)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8314",
    "data-name": "Path 8314",
    d: "M558.469,936.64c56.488-47.75,96.823-93.129,90.092-101.355s-57.982,23.813-114.47,71.564S437.268,999.974,444,1008.2,501.981,984.388,558.469,936.64Z",
    transform: "translate(-172.732 -456.879)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8315",
    "data-name": "Path 8315",
    d: "M556.508,926.292c59.083-51.516,101.186-100.141,94.039-108.609s-60.837,26.429-119.921,77.942S429.44,995.768,436.587,1004.232,497.424,977.8,556.508,926.292Z",
    transform: "translate(-169.815 -446.196)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8316",
    "data-name": "Path 8316",
    d: "M554.423,916.012C616.176,860.5,660.041,808.383,652.4,799.6s-63.9,29.095-125.652,84.6-105.618,107.629-97.975,116.412S492.67,971.522,554.423,916.012Z",
    transform: "translate(-166.733 -435.212)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8317",
    "data-name": "Path 8317",
    d: "M552.26,905.254c64.314-59.59,109.783-115.332,101.558-124.5s-67.029,31.7-131.343,91.3-109.783,115.332-101.558,124.5S487.946,964.845,552.26,905.254Z",
    transform: "translate(-163.628 -423.748)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8318",
    "data-name": "Path 8318",
    d: "M550.6,893.679C617.455,829.833,664.5,770.339,655.68,760.8s-70.167,34.483-137.022,98.329-113.9,123.341-105.08,132.885S483.746,957.527,550.6,893.679Z",
    transform: "translate(-160.722 -411.613)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8319",
    "data-name": "Path 8319",
    d: "M548.707,881.871C618.068,813.6,666.652,750.235,657.223,740.34s-73.3,37.425-142.66,105.693S396.617,977.67,406.046,987.566,479.346,950.138,548.707,881.871Z",
    transform: "translate(-157.738 -399.177)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8320",
    "data-name": "Path 8320",
    d: "M546.675,870c71.9-72.938,121.985-140.426,111.858-150.741S581.905,759.711,510,832.648,388.016,973.075,398.143,983.391,474.771,942.938,546.675,870Z",
    transform: "translate(-154.6 -386.358)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8321",
    "data-name": "Path 8321",
    d: "M545.311,857.322c74.242-77.637,125.638-149.256,114.794-159.968s-79.819,43.54-154.061,121.174S380.406,967.785,391.25,978.5,471.068,934.956,545.311,857.322Z",
    transform: "translate(-151.852 -373.037)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M543.924,843.989C620.518,761.4,673.1,685.327,661.358,674.083s-83.343,46.6-159.938,129.19S372.25,961.935,383.987,973.181,467.33,926.583,543.924,843.989Z",
    transform: "translate(-148.94 -358.865)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8323",
    "data-name": "Path 8323",
    d: "M542.841,830.839C621.649,743.187,675.347,662.669,662.779,651s-86.643,49.919-165.45,137.569S364.823,956.735,377.391,968.409,464.033,918.487,542.841,830.839Z",
    transform: "translate(-146.291 -344.827)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8324",
    "data-name": "Path 8324",
    d: "M541.945,816.766c80.857-92.818,135.391-177.973,121.806-190.2s-90.145,53.108-171,145.927-135.39,177.972-121.806,190.2S461.089,909.586,541.945,816.766Z",
    transform: "translate(-143.675 -329.948)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8325",
    "data-name": "Path 8325",
    d: "M541.763,803.423C624.6,705.255,679.82,615.28,665.111,602.459S571.33,658.826,488.5,756.994,350.44,945.137,365.15,957.961,458.931,901.592,541.763,803.423Z",
    transform: "translate(-141.296 -315.271)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8326",
    "data-name": "Path 8326",
    d: "M541.367,789.253c84.544-103.542,140.225-198.325,124.367-211.7s-97.252,59.718-181.8,163.262-140.226,198.327-124.367,211.7S456.823,892.8,541.367,789.253Z",
    transform: "translate(-138.99 -300.108)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8327",
    "data-name": "Path 8327",
    d: "M541.782,767.058C627.926,661.273,683.808,564.489,666.6,550.885s-101,61.122-187.141,166.907S337.43,920.362,354.641,933.965,455.638,872.842,541.782,767.058Z",
    transform: "translate(-136.903 -277.784)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8328",
    "data-name": "Path 8328",
    d: "M542.6,752.832c87.484-111.38,143.26-213.251,124.581-227.537S562.443,589.719,474.96,701.1,331.7,914.346,350.379,928.632,455.122,864.211,542.6,752.832Z",
    transform: "translate(-135.046 -262.19)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8329",
    "data-name": "Path 8329",
    d: "M543.922,738.574C632.534,621.492,687.864,514.381,667.5,499.334S558.8,567,470.19,684.084s-143.942,224.2-123.581,239.242S455.309,855.654,543.922,738.574Z",
    transform: "translate(-133.334 -246.359)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8330",
    "data-name": "Path 8330",
    d: "M545.641,723.6c89.378-122.724,143.933-234.974,121.851-250.717S555.055,543.862,465.677,666.586,321.745,901.559,343.826,917.3,456.263,846.319,545.641,723.6Z",
    transform: "translate(-131.979 -230.238)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8331",
    "data-name": "Path 8331",
    d: "M547.965,708.736c89.907-128.471,143.242-246.044,119.126-262.6S550.54,520.293,460.633,648.766,317.39,894.813,341.506,911.373,458.057,837.212,547.965,708.736Z",
    transform: "translate(-130.725 -213.922)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8332",
    "data-name": "Path 8332",
    d: "M551.37,693.619C641.5,559.369,693.176,436.418,666.791,419s-120.84,77.287-210.97,211.535S314.014,887.733,340.4,905.154,461.24,827.864,551.37,693.619Z",
    transform: "translate(-129.864 -197.366)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M555.23,678.725c90.027-140.031,139.663-268.339,110.864-286.583S540.969,472.625,450.943,612.656,311.28,880.995,340.079,899.238,465.2,818.754,555.23,678.725Z",
    transform: "translate(-129.235 -180.984)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M559.911,664.6c89.458-145.625,136.323-279.235,104.677-298.426s-129.82,83.3-219.279,228.927S308.986,874.338,340.632,893.53,470.452,810.224,559.911,664.6Z",
    transform: "translate(-128.787 -165.123)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8335",
    "data-name": "Path 8335",
    d: "M565.18,650.666c88.544-151.212,132.231-290.06,97.578-310.124S528.235,426.795,439.691,578.008s-132.231,290.06-97.578,310.123S476.636,801.88,565.18,650.666Z",
    transform: "translate(-128.583 -149.475)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8336",
    "data-name": "Path 8336",
    d: "M570.894,636.67c87.188-156.694,126.97-300.746,88.855-321.75s-139.694,89-226.883,245.691S305.9,861.36,344.011,882.361,483.705,793.366,570.894,636.67Z",
    transform: "translate(-128.316 -133.822)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8337",
    "data-name": "Path 8337",
    d: "M578.3,623.631c85.431-162.061,120.6-311.258,78.552-333.239s-145.39,91.576-230.821,253.637-120.6,311.258-78.551,333.239S492.865,785.692,578.3,623.631Z",
    transform: "translate(-128.384 -118.827)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M586.249,610.4c83.168-167.2,113-321.314,66.637-344.214s-151.372,94.083-234.54,261.287-113,321.314-66.638,344.212S503.081,777.6,586.249,610.4Z",
    transform: "translate(-128.439 -104.035)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8339",
    "data-name": "Path 8339",
    d: "M594.964,597.615c80.457-172.2,104.115-331.1,52.84-354.911s-158.063,96.47-238.52,268.667-104.115,331.1-52.841,354.912S514.506,769.814,594.964,597.615Z",
    transform: "translate(-128.242 -89.68)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8340",
    "data-name": "Path 8340",
    d: "M603.9,585.675C681.136,408.77,697.8,245.4,641.116,220.769S475.869,319.587,398.631,496.493s-93.9,340.279-37.218,364.9S526.66,762.579,603.9,585.675Z",
    transform: "translate(-127.628 -76.278)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8341",
    "data-name": "Path 8341",
    d: "M614.1,574.979c73.543-181.317,82.159-348.908,19.245-374.324S459.811,301.623,386.268,482.941,304.109,831.85,367.022,857.265,540.556,756.3,614.1,574.979Z",
    transform: "translate(-126.519 -63.983)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8342",
    "data-name": "Path 8342",
    d: "M624.619,564.054c69.347-185.421,69-356.824-.776-382.837S441.285,284.432,371.937,469.856s-69,356.827.776,382.838S555.271,749.478,624.619,564.054Z",
    transform: "translate(-124.649 -52.124)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8343",
    "data-name": "Path 8343",
    d: "M635.786,554.571c64.69-189.169,54.236-363.975-23.349-390.44s-192.922,105.432-257.612,294.6-54.236,363.974,23.349,390.442S571.1,743.738,635.786,554.571Z",
    transform: "translate(-121.619 -41.713)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8344",
    "data-name": "Path 8344",
    d: "M647.214,545.285c59.569-192.542,37.852-370.245-48.5-396.912s-204.653,107.8-264.222,300.344-37.852,370.244,48.505,396.912S587.645,737.826,647.214,545.285Z",
    transform: "translate(-117.121 -32.144)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8345",
    "data-name": "Path 8345",
    d: "M658.4,536.577c54.036-195.6,19.86-375.677-76.335-402.214S364.088,244.877,310.052,440.477s-19.86,375.677,76.335,402.217S604.366,732.177,658.4,536.577Z",
    transform: "translate(-110.692 -23.682)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8346",
    "data-name": "Path 8346",
    d: "M670.352,528.554c48.123-198.223.216-379.994-107-406S330.216,236.168,282.1,434.392s-.216,380,107,406S622.231,726.781,670.352,528.554Z",
    transform: "translate(-102.478 -16.613)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8347",
    "data-name": "Path 8347",
    d: "M681.966,521c41.828-200.363-21.143-383-140.652-407.936s-250.3,117.278-292.131,317.641,21.143,383,140.653,407.937S640.136,721.368,681.966,521Z",
    transform: "translate(-91.879 -11.017)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8348",
    "data-name": "Path 8348",
    d: "M693.874,513.6C729.148,311.392,649.6,128.613,516.2,105.353S246.074,227.161,210.8,429.371s44.275,384.989,177.672,408.25S658.6,715.811,693.874,513.6Z",
    transform: "translate(-78.675 -6.565)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8349",
    "data-name": "Path 8349",
    d: "M706.139,505.344C734.6,301.7,637.078,119.754,488.32,98.969S195.9,226.423,167.438,430.073,236.5,815.664,385.254,836.449,677.678,709,706.139,505.344Z",
    transform: "translate(-63.076 -2.993)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8350",
    "data-name": "Path 8350",
    d: "M718.508,497.836c21.458-204.615-95.6-384.589-261.46-401.983S139.337,230.231,117.877,434.845s95.6,384.588,261.457,401.98S697.043,702.448,718.508,497.836Z",
    transform: "translate(-44.657 -1.456)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8351",
    "data-name": "Path 8351",
    d: "M732.2,488.146C746.568,282.775,608.389,105.813,423.577,92.89S77.3,235.977,62.942,441.348,186.761,823.68,371.573,836.6,717.846,693.517,732.2,488.146Z",
    transform: "translate(-23.792 -0.026)",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8352",
    "data-name": "Path 8352",
    d: "M373.754,837.607c205.866,0,372.755-166.888,372.755-372.754S579.62,92.1,373.754,92.1,1,258.986,1,464.853,167.888,837.607,373.754,837.607Z",
    fill: "none",
    stroke: "#991010",
    strokeWidth: 1.235
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.1a5b79a0bab5a4dbe09ae575797e49c8.svg";
export { ForwardRef as ReactComponent };